import { galleryPreviewImages } from '../../data/gallery'
import { ProtectionSelector } from '../protection/protection-selector'
import { ButtonLink } from '../ui/button'

export interface ServicesSectionProps {}

export function ServicesSection(_: Readonly<ServicesSectionProps>) {
  return (
    <>
      <section className="packages-overlap-section" id="services" aria-labelledby="packages-heading">
        <div className="section-container">
          <div className="center-heading">
            <p className="eyebrow">GYEON Ceramic Protection</p>
            <h2 id="packages-heading">Choose a protection level</h2>
            <p>
              1, 3 and 5 Year GYEON ceramic coatings. Select a protection level to start a booking,
              or explore the full ceramic protection page.
            </p>
          </div>
          <ProtectionSelector variant="preview" />
          <div className="gallery-action">
            <ButtonLink href="/ceramic-protection">Explore Ceramic Protection</ButtonLink>
          </div>
        </div>
      </section>

      <section className="detailing-teaser-section" id="detailing" aria-labelledby="detailing-heading">
        <div className="section-container detailing-teaser-grid">
          <img
            src="/images/home-page-mercedes-benz.png"
            alt="A luxury Mercedes-Benz after professional studio detailing."
            width="1376"
            height="768"
            loading="lazy"
          />
          <div>
            <p className="eyebrow">Professional Detailing</p>
            <h2 id="detailing-heading">Tailored work, not fixed packages.</h2>
            <p>
              Exterior detailing, premium detailing and enhancement, and paint protection
              recommended for your vehicle.
            </p>
            <ul>
              <li>Exterior Detailing</li>
              <li>Premium Detailing &amp; Enhancement</li>
              <li>Paint Protection</li>
            </ul>
            <ButtonLink href="/detailing" variant="solid">Explore Detailing Services</ButtonLink>
          </div>
        </div>
      </section>

      <section className="results-gallery" id="studio" aria-labelledby="gallery-heading">
        <div className="section-container">
          <div className="center-heading">
            <p className="eyebrow">Our Work</p>
            <h2 id="gallery-heading">Studio results</h2>
            <p>A short preview of Autoglow studio imagery.</p>
          </div>
          <div className="gallery-grid homepage-gallery-preview">
            <a className="gallery-feature" href="/gallery">
              <img
                src={galleryPreviewImages[0].src}
                alt={galleryPreviewImages[0].alt}
                width="900"
                height="620"
                loading="lazy"
              />
            </a>
            <div>
              {galleryPreviewImages.slice(1, 4).map((item) => (
                <img src={item.src} alt={item.alt} width="440" height="300" loading="lazy" key={item.src} />
              ))}
            </div>
          </div>
          <div className="gallery-action">
            <ButtonLink href="/gallery" variant="ghost">View Full Gallery</ButtonLink>
          </div>
        </div>
      </section>
    </>
  )
}
